module.exports = __webpack_public_path__ + "../static/img/_default.475ec729.png";